export const CUBA_APP_URL = process.env.REACT_APP_CUBA_URL || "/app/rest/";
export const CUBA_APP_NOTIFICATION_WS_URL =
  process.env.REACT_APP_CUBA_NOTIFICATION_WS_URL || "/adhr-core/ws/handler";
export const CUBA_IDP_ENABLE = true;
export const CUBA_DISPATCHER = process!.env.REACT_APP_CUBA_URL!.replace("rest", "dispatch");

export const DEFAULT_COUNT = 10; // Typical amount of entities to be loaded on browse screens
